import React, { useEffect } from "react"
import { useDispatch } from "react-redux"
import { useParams } from "react-router-dom"

import RunSummary from "./components/RunSummary"
import RunBillsTable from "./components/RunBillsTable"
import { clearRunReview, fetchRunBills } from "./clientBatchingSlice"

// The Flagged tab (A/R feedback item 1): the run's red-flagged bills, held out of the run until
// their current charges add up. The same grid as Review Bills, fixed to the red_flagged state.
export default function RunFlaggedPage() {
    const dispatch = useDispatch()
    const { runId } = useParams()

    useEffect(() => {
        dispatch(clearRunReview({ runId }))
        dispatch(fetchRunBills(runId, { state: "red_flagged", pagination: { current: 1, pageSize: 50 } }))
        return () => dispatch(clearRunReview())
    }, [dispatch, runId])

    return (
        <div>
            <RunSummary />
            <div style={{ marginTop: "20px" }}>
                <RunBillsTable mode="flagged" />
            </div>
        </div>
    )
}
